/**
 * AdminSalesTrend — "National Trend · 6 weeks" card. Renders the Actual
 * weekly-revenue series via the SparkArea primitive (recharts). There is
 * no forecast data source, so the Forecast legend item renders with no
 * series (the line is omitted, not fabricated).
 */
import { SparkArea, type SparkLinePoint } from '../primitives';

import type { AdminSalesDto } from './adminApi';

/** Trend points → SparkArea shape (dollar values, week-start label). */
export function toTrendPoints(trend: AdminSalesDto['nationalTrend']): SparkLinePoint[] {
  if (trend === null) return [];
  return trend.map((p) => ({
    label: p.weekStartIso.slice(5), // MM-DD
    value: Math.round(p.revenueCents / 100),
  }));
}

function TrendLegend() {
  return (
    <div style={{ display: 'flex', gap: 14, fontSize: 11, color: 'var(--nb-subtle)' }}>
      <span>
        <i
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: 2,
            background: 'var(--nb-primary)',
            marginRight: 6,
            verticalAlign: '-1px',
          }}
        />
        Actual
      </span>
      <span>
        <i
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: 2,
            border: '1px dashed var(--nb-border-2)',
            marginRight: 6,
            verticalAlign: '-1px',
          }}
        />
        Forecast
      </span>
    </div>
  );
}

export function AdminSalesTrend({ trend }: { trend: AdminSalesDto['nationalTrend'] }) {
  const points = toTrendPoints(trend);
  return (
    <section className="nb-card" style={{ flex: '0 0 auto' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={{ fontSize: 13, letterSpacing: '.04em', margin: 0 }}>
          National Trend · 6 weeks
        </h3>
        <TrendLegend />
      </div>
      {points.length > 0 ? (
        <SparkArea data={points} height={110} />
      ) : (
        <div style={{ fontSize: 12, color: 'var(--nb-subtle)', padding: '24px 0' }} role="note">
          Weekly trend unavailable.
        </div>
      )}
    </section>
  );
}
